import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/login"); return; }
    const session_id = match[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        if (data.token) localStorage.setItem("gf_token", data.token);
        setUser(data.user);
        window.history.replaceState(null, "", "/");
        navigate(data.user.role === "admin" ? "/admin" : "/", { state: { user: data.user } });
      } catch (e) {
        console.error("auth callback failed", e);
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
      <div className="hero-orb" style={{ width: 500, height: 500, opacity: .4 }}/>
      <div className="surface px-10 py-8 text-center relative z-[2]">
        <span className="eyebrow">Signing you in</span>
        <div className="font-serif text-[1.6rem] font-semibold mt-2">Adding sparkle to your session…</div>
        <p className="text-sm text-[var(--ink-soft)] mt-1">Just a moment ♡</p>
      </div>
    </div>
  );
}
